import { dynamic } from './dynamic';
import { getLogsQS } from './logs';
import { settings } from './settings';

export const vlAccessMappers = {
  getLogsQS,
  settings,
  dynamic,
};
